<template>
  <div class="onboarding-info-section">
    <div class="onboarding-welcome-message">
      <div class="ai-title">
        <div class="ai-icon">
          <img src="@/assets/ai/ai_bot_avatar.png">
        </div>
        <div class="default-text">
          <span>{{attendeeAssistant}}</span>
        </div>
      </div>
      <div class="ai-message">
        {{config.openingRemarks}}
      </div>
      <div class="ai-optional-conditions" v-if="onboardingInfo.suggested_questions">
        <div class="optional-conditions-item" v-for="suggest in onboardingInfo.suggested_questions" :key="suggest" @click="onSuggest(suggest)">
          <div class="item-icon">
            <img src="@/assets/ai/ai_greet.png">
          </div>
          <div class="item-text">{{suggest}}</div>
          <div class="item-arrow">
            <img src="@/assets/ai/ai_right.png">
          </div>
        </div>
      </div>
    </div>
    <!-- <div class="onboarding-info-header">
      <div class="onboarding-info-inner">
        <img class="onboarding-bg" src="https://ef-imaster-file.oss-cn-beijing.aliyuncs.com/izt_static/h5/tangjiu/onboarding_title_bg.png" alt="">
        <div class="onboarding-title-content">
          <div class="onboarding-bot">
            <img width="32" src="../../../assets/ai/ai_bot_avatar.png" alt="">
          </div>
          <div class="onboarding-title">您可以向我咨询{{config.appName}}相关信息</div>
        </div>
      </div>
    </div> -->

    <!-- <div class="onboarding-info-list">
      <div class="onboarding-list scrollbar-width-none" v-if="onboardingInfo.suggested_questions">
        <div class="onboarding-list-item" v-for="suggest in onboardingInfo.suggested_questions" :key="suggest" @click="onSuggest(suggest)">{{suggest}}</div>
      </div>
    </div> -->
  </div>
</template>

<script>
  import { mapGetters } from 'vuex'

  export default {
    props: {
      config: {
        type: Object,
        default: () => ({})
      },
      onboardingInfo: {
        type: Object,
        default: () => ({
          prologue: "",
          suggested_questions: []
        })
      }
    },
    data() {
      return {}
    },
    computed: {
      ...mapGetters(['lang']),
      // 我是您的智能参会助手
      attendeeAssistant() {
        const text = {
          cn: '我是您的智能参会助手',
          en: 'I am your AI Assistant for the event.'
        }[this.lang]
        return text || '我是您的智能参会助手'
      }
    },
    methods: {
      onSuggest(text) {
        this.$emit('send', text)
      }
    }
  }
</script>

<style lang="scss" scoped>
  .onboarding-info-section {
    padding-top: calc(20px - 12px);
    padding-left: calc(15px - 12px);
    padding-right: calc(32px - 12px);
    .onboarding-welcome-message {
      border-radius: 10px 10px 10px 0px;
      background: #FBFBFB;
      box-shadow: 0px 2px 4px 0px rgba(7,41,177,0.05);
      padding: 12px;
      .ai-title {
        display: flex;
        align-items: center;
        .ai-icon {
          margin: 0;
          padding: 0;
          overflow: hidden;
          margin-right: 5px;
          display: flex;
          align-items: center;
          img {
            width: 20px;
            object-fit: contain;
          }
        }
        .default-text {
          flex: 1;
          line-height: 21px;
          span {
            font-size: 14px;
            font-weight: 500;
            color: rgba(0,0,0,0.85);
          }
        }
      }
      .ai-message {
        margin-top: 8px;
        font-weight: 400;
        font-size: 13px;
        color: rgba(0,0,0,0.45);
        line-height: 16px;
        text-align: left;
      }
      .ai-optional-conditions {
        display: flex;
        flex-direction: column;
        gap: 8px 0;
        margin-top: 18px;
        .optional-conditions-item {
          display: flex;
          padding: 12px 8px;
          padding-right: 14px;
          box-sizing: border-box;
          background: linear-gradient( 270deg, #737EFF 0%, #9F8DFC 100%);
          box-shadow: 0px 2px 4px 0px rgba(7, 41, 177, 0.05);
          border-radius: calc(25px / 2);
          align-items: center;
          cursor: pointer;
          &:hover {
            opacity: 0.9;
          }
          .item-icon {
            width: 20px;
            height: 20px;
            background: linear-gradient( 270deg, #73E3FF 0%, #998DFC 100%);
            box-shadow: 0px 2px 4px 0px rgba(7, 41, 177, 0.05);
            border-radius: 50%;
            display: flex;
            align-items: center;
            justify-content: center;
            margin-right: 8px;
            img {
              width: 12px;
            }
          }
          .item-text {
            font-weight: bold;
            font-size: 14px;
            color: #FFFFFF;
            line-height: 21px;
            flex: 1;
          }
          .item-arrow {
            width: 12px;
            height: 15px;
            display: flex;

            img {
              height: 100%;
              object-fit: contain;
            }
          }
        }
      }
      img {
        pointer-events: none!important;
      }
    }
  }
  // .onboarding-info-header {
  //   width: fit-content;
  //   max-width: 90vw;
  //   height: 35px;
  //   margin: 0 auto;
  //   .onboarding-info-inner {
  //     width: 100%;
  //     height: 100%;
  //     position: relative;
  //     .onboarding-bg {
  //       display: block;
  //       width: 100%;
  //       height: 100%;
  //       position: absolute;
  //       left: 0;
  //       top: 0;
  //     }
  //     .onboarding-title-content {
  //       display: flex;
  //       align-items: center;
  //       padding-left: 5px;
  //       padding-right: 10px;
  //     }
  //     .onboarding-bot {
  //       width: 35px;
  //       height: 35px;
  //       position: relative;
  //       display: flex;
  //       align-items: center;
  //       justify-content: center;
  //       img {
  //         display: block;
  //       }
  //     }
  //     .onboarding-title {
  //       flex: 1;
  //       font-weight: bold;
  //       font-size: 14px;
  //       color: #FFFFFF;
  //       text-align: center;
  //       position: relative;
  //       line-height: 35px;
  //       margin-left: 5px;
  //     }
  //   }
  // }
  // .onboarding-info-list {
  //   .onboarding-list {
  //     width: 100%;
  //     overflow-x: auto;
  //     white-space: nowrap;
  //     .onboarding-list-item {
  //       display: inline-block;
  //       font-weight: 400;
  //       font-size: 14px;
  //       color: rgba(0,0,0,0.65);
  //       padding: 8px 12px;
  //       border-radius: 5px;
  //       border: 1px solid rgba(0,0,0,0.1);
  //       margin-right: 12px;
  //       background: #FFFFFF;
  //       line-height: 1.2;
  //       &:last-child {
  //         margin-right: 0;
  //       }
  //     }
  //   }
  // }
</style>